// extracted by mini-css-extract-plugin
export default {"link":"Index_link__eXa8x","url":"Index_url__W3ckF","small":"Index_small__DlxVo","large":"Index_large__rp+D4"};